import { request } from "../utils/request.js"

export const saleOrder_exportForManage = (pojo, args) => request({
    url: 'saleOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageForManage = (pojo, args) => request({
    url: 'saleOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_getSumDataForManage = (pojo, args) => request({
    url: 'saleOrder/getSumDataForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: false,
    ...args
})

export const saleOrder_addNewQuick = (pojo, args) => request({
    url: 'saleOrder/addNewQuick',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_addNew = (pojo, args) => request({
    url: 'saleOrder/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_update = (pojo, args) => request({
    url: 'saleOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_deleteById = (id, args) => request({
    url: 'saleOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_findById = (id, args) => request({
    url: 'saleOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleOrder_findHeadVoById = (id, args) => request({
    url: 'saleOrder/findHeadVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleOrder_findVoById = (id, args) => request({
    url: 'saleOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleOrder_getSaleRank = (pojo, args) => request({
    url: 'saleOrder/getSaleRank',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_commoditySaleReport_sum = (pojo, args) => request({
    url: 'saleOrder/commoditySaleReport/sum',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_commoditySaleReport_item = (pojo, args) => request({
    url: 'saleOrder/commoditySaleReport/item',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_commoditySaleReport_export = (pojo, args) => request({
    url: 'saleOrder/commoditySaleReport/export',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/saleOrder.js